import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import TabAddCompliance from './TabAddCompliance';
import { getConfigCompliance, postAddCompliance, postUpdateCompliance } from 'redux/actions/UserCompliance';
import { addCompliance, subVendorComplainceData } from './DataAddCompliance';
import CommonDialog from 'components/commonDialog/CommonDialog';



function AddComplianceView() {

  const dispatch = useDispatch();
  const [value, setValue] = useState('subVendor'); // remove vendor default value ---vendorCompany
  let tableData = useSelector(state => state?.userConfigCompliance?.userConfigCompliance?.data)
  let loader = useSelector(state => state?.userConfigCompliance?.loading)
  const [tableDetails, setTableDetails] = useState(tableData);
  const [open, setOpen] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [defaultValue, setDefaultValue] = useState({})
  let filterData = {
    page:page,
    pageSize:rowsPerPage,
  }

  const breadcrumbPaths = [
    // { name: 'Configure', url: '', className: 'colorGrey fontSemi' },
    { name: 'Compliance', url: '', className: 'colorBlue' },
  ];

  useEffect(() => {
    const type = {
      type: value+'Registration'
    }
    dispatch(getConfigCompliance({...filterData, ...type}));
  }, []);

  useEffect(() => {
    setTableDetails(tableData)
  }, [tableData]);

  const handleChange = (val) => {
    setPage(0)
    setValue(val)
    const type = {
      type: val+'Registration'
    }
    dispatch(getConfigCompliance({...filterData, ...type, page: 0}))
  }

  const onSubmit = (val, type) => {
    const data = {
      type:value,
      "complianceType":value+'Registration',
      "attributeType":val?.type,
      "attributeName":val?.docsName,
      "isExpiring":val?.isExpiring,
      "isMandatory":val?.isMandatory
    }
    dispatch(postAddCompliance(data))
  }

  const onCheckChange = (ele, key, index) => {
    let data = {}
    let newArray = []
    newArray = tableData?.body
    const isTrue = (ele[key] !== null ? !ele[key] : true)
    newArray[index][key] = isTrue
    tableData = {...tableData, body:newArray}
    data[key] = isTrue
    data={...data, id:ele?.id, type:value+'Registration'}
    setTableDetails(tableData)
    dispatch(postUpdateCompliance({...data, ...filterData}))
  }

  const handleChangePage = (event,newPage) => {
    setPage(newPage)
    dispatch(getConfigCompliance({...filterData, page:newPage, type: value+"Registration"}))
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getConfigCompliance({...filterData, page:0, pageSize:parseInt(event.target.value), type: value+"Registration"}))
  }

  const handleClose = () => {
    setOpen(false);
  };

  const onDialog = (data) => { 
    const updatedData = {...data, id:data?.id, type:value+'Registration', ...filterData};

    dispatch(postUpdateCompliance(updatedData))
    handleClose()
  }

  const onClickMoreIcon = (data, iconType) => {
    if(value === "subVendor"){
      if (iconType === 'Edit') {
        setDefaultValue(data)
        setOpen(true);
      }
    } else if(value === "driver") {
      if (iconType === 'Edit') {
        setDefaultValue(data)
        setOpen(true);
      }
    }else if(value === "vehicle") {
      if (iconType === 'Edit') {
        setDefaultValue(data)
        setOpen(true);
      }
    }
  }

  return (
    <div>
    <CommonBreadCrumb paths={breadcrumbPaths}/>
    <TabAddCompliance
      onSubmittBtn={onSubmit}
      formData={addCompliance(value)}
      handleChange={handleChange}
      tableData={tableDetails}
      onCheckChange={onCheckChange} 
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      onClickMoreIcon={onClickMoreIcon}
      page={page}
      rowsPerPage={rowsPerPage}
      loader={loader}
       />

      {open && (
        <CommonDialog
          open={open}
          handleClose={handleClose}
          formData={subVendorComplainceData}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          type={'Edit Compliance'}
          selectType={'edit'}
          defaultValues={defaultValue}
        />
      )}
    </div>
  )
}

export default AddComplianceView;